module.exports = __webpack_public_path__ + "static/media/Hus-min.be0d2e1d.PNG";